import React from 'react';
import {useSelector} from 'react-redux';
import {UiText, UiQuestionnaireLayout, Col, UiImage, Row} from '~/components/elements';
import SpecialText from '~/components/shared/SpecialText';
import {WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {RootState} from '~/redux/root-reducer';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire8Screen = () => {
  const {questionnaires} = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.BMI_UNDERWEIGHT);
  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[WEIGHT_LOSS_KEYS.BMI_CALCULATOR]?.data,
  );

  return (
    <UiQuestionnaireLayout actions={questionnaire?.actions}>
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.ultra} mt={spacing.medium} />
        <UiText fontSize="2xl" fontWeight="bold" mt="24px">
          {questionnaire?.questions?.default}
        </UiText>
        <UiText color="blackSecondary" fontSize="sm" mt="24px">
          {questionnaire?.questions?.sub}
        </UiText>
        <Row mt="22px" px={spacing.medium} align="center">
          <UiText color="blackSecondary" fontSize="lg">
            {questionnaire?.descriptions?.sub}
          </UiText>
          <UiText fontWeight={700} fontSize="lg" ml={2}>
            {currentAnswer?.bmi}
          </UiText>
        </Row>
        <Col mt="16px">
          {questionnaire?.descriptions?.default?.map(desc => (
            <SpecialText text={desc} key={desc} />
          ))}
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire8Screen;
